import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlask } from '@fortawesome/free-solid-svg-icons';
import { categories, endemismStats, iucnCategories } from '../constants/floraFaunaData';
import CategoryGrid from './FloraFauna/CategoryGrid';
import EndemismSection from './FloraFauna/EndemismSection';
import ConservationStatusChart from './FloraFauna/ConservationStatusChart';

const FloraFaunaSection = () => {
    return (
        <section className="py-24 relative overflow-hidden bg-white" id="living-archive">
            {/* Technical Grid Background */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'radial-gradient(#0f172a 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

            <div className="container mx-auto px-6 relative z-10">
                {/* Header Section */}
                <div className="max-w-4xl mx-auto text-center mb-24">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                   
                        <span className="inline-flex items-center space-x-2 px-4 py-1.5 bg-white rounded-full text-slate-900 font-bold text-[10px] uppercase tracking-widest mb-8 shadow-lg">
                            <FontAwesomeIcon icon={faFlask} className="text-emerald-400 animate-pulse text-sm" />
                            <span>Scientific Record Hub</span>
                        </span>

                        <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-6 sm:mb-8 font-display leading-[1.2] sm:leading-[1.1]">
                            Biodiversity <span className="text-emerald-600">Inventory.</span>
                        </h2>

                        <p className="text-sm sm:text-lg text-slate-500 font-medium leading-relaxed max-w-2xl mx-auto italic">
                            A high-fidelity mapping of global and regional biological richness, organized by scientific classification.
                        </p>
                    </motion.div>
                </div>

                {/* Taxonomic Category Grid */}
                <CategoryGrid categories={categories} />

               
            </div>
        </section>
    );
};

export default FloraFaunaSection;